"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var winnerCard_1 = __importDefault(require("./winnerCard"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_transition_group_1 = require("react-transition-group");
var LastWinnersLiveFeed = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)();
    var data = (0, swr_hooks_1.useLastWinnersFlexInterval)().data;
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return null;
    return (react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: styles_module_scss_1.default.lastWinnersWrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.liveFeed }, t('translation.liveFeed')), data === null || data === void 0 ? void 0 :
        data.map(function (winner, idx) {
            var gameId = winner === null || winner === void 0 ? void 0 : winner.gameId;
            var winnerName = (winner === null || winner === void 0 ? void 0 : winner.nickname) || t('common.anonymous');
            if (!gameId)
                return null;
            return (react_1.default.createElement(winnerCard_1.default, { key: "".concat(winner.gameTitle).concat(idx).concat(winner === null || winner === void 0 ? void 0 : winner.gameId), title: (winner === null || winner === void 0 ? void 0 : winner.gameTitle) || '', playerName: winnerName, imageUrl: (0, apps_shared_1.getGameImageURL)(winner === null || winner === void 0 ? void 0 : winner.gameId) || '', prize: "".concat((0, apps_shared_1.getCurrencySymbol)(winner.currency)).concat(winner.winAmount), gameId: winner === null || winner === void 0 ? void 0 : winner.gameId, slug: winner === null || winner === void 0 ? void 0 : winner.slug, gameCardPlaceholder: gameCardPlaceholder }));
        })));
};
exports.default = react_1.default.memo(LastWinnersLiveFeed);
